<template>
  <div>
    <!-- {{this.box}} -->
        <v-card>
          <v-card-title>
            Add or delete users role
            <v-spacer></v-spacer>
          </v-card-title>
          <v-text-field
          v-model="boxname"
          :value="boxname"
          solo
          dense
          :prepend-inner-icon="prependIcon"
          readonly
        ></v-text-field>
          <v-data-table
            :headers="headers"
            :items="boxOpeners"
            :search="search"
            dense
            :loading="loading"
            loading-text="Loading... Please wait"
            hide-default-footer
          >
            <template v-slot:item.IsAdmin="{ item }">
              <v-btn
                :color="item.Color"
                dark
                rounded
                x-small
                min-width="100"
                :class="`d-flex justify-space-around mb-4`"
                @click="deleteUserFromRole(item)"
                :outlined="item.Outlined"
              >
                <v-icon x-small>fa-trash-alt</v-icon>
              </v-btn>
            </template>
          </v-data-table>
          <ul v-if="errors && errors.length">
            <li v-for="error of errors" :key="error.id" style="color:Red;">{{error.message}}</li>
          </ul>
        </v-card>
        <div>.</div>
        <v-btn rounded small color="primary" @click="getboxOpeners(boxid)">Refresh</v-btn>
        <v-btn rounded small color="primary" @click="showUserSearch = !showUserSearch">ADD USER/ROLE</v-btn>
        <v-alert type="success" :value="isAlertVisible">
          {{statusResultMsg}}
          <v-btn small color="primary" @click="getboxOpeners(boxid)">Refresh</v-btn>
        </v-alert>
        <v-alert type="error" :value="isWarningAlertVisible">{{statusResultMsg}}</v-alert>
        <div v-if="showUserSearch">
          <UserApiSearch @selected-regid="setRegId"></UserApiSearch>
          <v-row align="center" justify="center">
            <v-col cols="6">
              <v-radio-group v-model="radios" :mandatory="true" small row>
                <v-radio label="Opener" value="3"></v-radio>
                <v-radio label="Administrator" value="2"></v-radio>
              </v-radio-group>
            </v-col>
            <v-col cols="2">
              <v-btn
                color="primary"
                small
                rounded
                @click="addUserToRole(addregId,radios)"
                :class="`d-flex justify-space-around mb-6`"
                :disabled="!addUserEnabled"
              >
                Add
              </v-btn>
            </v-col>
          </v-row>
        </div>
  </div>
</template>

<script>
import axios from "axios";
// import copybutton from "@/components/Copy.vue";
import UserApiSearch from "@/components/airbox/UserApiSearch.vue";

export default {
  name: "BoxRoles",
  props: {
    box:[],
    regId: Number,
    ac: String
  },
  data() {
    return {
      search: "",
      loading: true,
      prependIcon: null,

      headers: [
        { text: "Name", value: "Name" },
        { text: "Delete", value: "IsAdmin" },
        { text: "Mobile", value: "MID" },
        { text: "Role", value: "RoleName" }
      ],
      boxOpeners: [],
      errors: [],
      cancellink: { to: "/events" },
      isValid: true,
      statusResult: Number,
      statusResultMsg: String,
      isAlertVisible: false,
      isWarningAlertVisible: false,
      showUserSearch: false,
      addregId: Number,
      addUserEnabled: false,
      radios: 3,
      boxid: Number,
      boxname: String
    };
  },

  created() {
    this.baseUrl = "https://pgapi.azurewebsites.net/dbapi/";
    // this.baseUrl = "http://localhost:3000/dbapi/";
    // this.selectedEventText = null;
    // this.selectedAdminText = null;
    // this.selectedEventCommentText = null;
    this.continueEnabled1 = false;
    this.continueEnabled2 = false;
    // this.ac = null;
    //this.comment = null;
    this.boxid = this.box.EventId;
    this.boxname = this.box.Event;
    // console.log("regId",this.regId);
    this.getboxOpeners(this.boxid);
    
  },
  methods: {
    showAlert(a) {
      alert("Alert! \n" + a);
    },
    deleteUserFromRole(opener) {
    //   console.log(opener);
      var adminRegId = this.regId;
      var ac = this.ac;
      var eventId = this.box.EventId;
      var eventuserroleId = opener.EventUserRoleId;
      var toSubmit = JSON.stringify({ ac, eventId, eventuserroleId });
      const uri = this.baseUrl + "deleteeventrole/" + adminRegId;
    //   console.log(uri);
    //   console.log(toSubmit);
      this.isAlertVisible = false;
      this.isWarningAlertVisible = false;
      this.sendpost(uri, toSubmit, 1);
      //   this.getboxOpeners(this.selectedEvent);
    },

    addUserToRole(regId, roleId) {
      console.log(regId);
      var adminRegId = this.regId;
      var ac = this.ac;
      var eventId = this.box.EventId;
      //   var regId = regId;
      //   var roleId = roleId;
      var toSubmit = JSON.stringify({ ac, eventId, regId, roleId });
      const uri = this.baseUrl + "inserteventrole/" + adminRegId;
      // console.log(uri);
      // console.log(toSubmit);
      this.isAlertVisible = false;
      this.isWarningAlertVisible = false;
      this.showUserSearch = false;
      this.addUserEnabled = false;
      this.sendpost(uri, toSubmit, 1);
      //   this.getboxOpeners(this.selectedEvent);
    },

    getboxOpeners(boxid) {
      this.isAlertVisible = false;
      this.isWarningAlertVisible = false;
      var eventId = boxid;
      console.log("eventId",eventId)
      axios
        .get(this.baseUrl + "geteventroles/" + eventId)
        .then(response => {
          // JSON responses are automatically parsed.
          this.boxOpeners = response.data;
          this.loading = false;
        })
        .catch(e => {
          this.errors.push(e);
        });
    },
    setRegId(id) {
      console.log("id",id);
      this.addregId = id;
      this.addUserEnabled = true;
    },

    sendpost(uri, toSubmit, type) {
      const axiosConfig = {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          "Access-Control-Allow-Origin": "*"
        }
      };
      axios
        .post(uri, toSubmit, axiosConfig)
        .then(response => {
          // console.log(response.data);
          if (type === 0) {
            this.statusResult = response.data.Result;
            this.statusResultMsg = response.data.ResultMsg;
          } else {
            this.statusResult = response.data[0].Result;
            this.statusResultMsg = response.data[0].ResultMsg;
          }
          this.setAlert(this.statusResult);
          //   if (this.statusResult === 1) {
          //       getstatus();
          //   }
        })
        .catch(e => {
          this.errors.push(e);
          this.statusResult = 0;
          this.statusResultMsg = "Something went wrong!";
          this.setAlert(this.statusResult);
        });
    },
    setAlert(statusResult) {
      if (statusResult === 1) {
        this.isAlertVisible = true;
        this.isWarningAlertVisible = false;
      }
      if (statusResult === 0) {
        this.isWarningAlertVisible = true;
        this.isAlertVisible = false;
      }
    }
  },
  components: {
    UserApiSearch
    // copybutton
  }
};
</script>